/**
 * ลิงก์ไปหน้าผู้มีอำนาจลงนาม — หน้าเต็มตั้งแต่ 28 ต.ค. 2026 (เดิมเป็นโมดัลในหน้ารายการ)
 *   /master-data/authorized-signers          รายการ
 *   /master-data/authorized-signers/:id      รายละเอียด (authorized_signers.view)
 *   /master-data/authorized-signers/:id/edit แก้ไข (authorized_signers.view + authorized_signers.edit)
 *   /master-data/authorized-signers/new      เพิ่มใหม่ (authorized_signers.create)
 */
export const AUTHORIZED_SIGNERS_PATH = '/master-data/authorized-signers';
export const AUTHORIZED_SIGNER_NEW_PATH = `${AUTHORIZED_SIGNERS_PATH}/new`;

/** หน้ารายละเอียด — id ไม่ถูกต้อง = หน้ารายการ */
export function authorizedSignerDetailUrl(signerId: number | string | null | undefined): string {
  const n = Number(signerId);
  return Number.isInteger(n) && n > 0 ? `${AUTHORIZED_SIGNERS_PATH}/${n}` : AUTHORIZED_SIGNERS_PATH;
}

export function authorizedSignerEditUrl(signerId: number | string | null | undefined): string {
  const url = authorizedSignerDetailUrl(signerId);
  return url === AUTHORIZED_SIGNERS_PATH ? url : `${url}/edit`;
}
